export { AI_AGENT_PAGE_WIDTH } from "app/pages/sales-intelligence/modules/ai-agent/constants";

export const SUGGESTION_TEXTS = ["si.pages.ai_agent_email.suggestion_1", "si.pages.ai_agent_email.suggestion_2"];
